import { isAcceptanceTest } from 'hub-http/helpers/env';
export class InternalAuthError extends Error {
  constructor() {
    super('This app is only available to HubSpot employees.');
    this.name = 'InternalAuthError';
  }
}
export function assertInternalAuthEmail(emails) {
  const hasHubSpotEmail = emails.some(email => email === null || email === void 0 ? void 0 : email.toLowerCase().endsWith('@hubspot.com'));
  if (!hasHubSpotEmail && !isAcceptanceTest()) {
    throw new InternalAuthError();
  }
}